import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 43px;

  .PatientAlreadyCompletedMessage__Message {
    margin: 10px 0 30px 0;
    text-align: center;
  }

  button {
    width: 212px;
  }
`